import { render, staticRenderFns } from "./data2.vue?vue&type=template&id=6eff830d&scoped=true"
import script from "./data2.vue?vue&type=script&lang=js"
export * from "./data2.vue?vue&type=script&lang=js"
import style0 from "./data2.vue?vue&type=style&index=0&id=6eff830d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff830d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eff830d')) {
      api.createRecord('6eff830d', component.options)
    } else {
      api.reload('6eff830d', component.options)
    }
    module.hot.accept("./data2.vue?vue&type=template&id=6eff830d&scoped=true", function () {
      api.rerender('6eff830d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/hotelInit/data2.vue"
export default component.exports